export default __webpack_public_path__ + "static/media/healthierlogo.1bb7b67bfce281afc7a57fb92facfce8.webp";